import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ShareReferralDrawer from '../../components/modal/ShareReferralDrawer';
import cable from '../../cable';
import { hideModal } from '../../actions/modal';
import { getReferralsQuery } from '../../actions/records';

export const SharedReferralDrawerDialog = ({
  fileToken,
  closeModal,
  refreshReferrals,
  pathname,
  search,
}) => {
  const [visible, setVisible] = useState(false);
  const [shouldRefreshOnClose, setShouldRefreshOnClose] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const handleClose = () => {
    setVisible(false);
  };

  const handleRevoked = () => {
    setShouldRefreshOnClose(true);
    setVisible(false);
  };

  const handleActivityRead = () => {
    setShouldRefreshOnClose(true);
  };

  const handleAfterVisibleChange = async (isOpen) => {
    if (isOpen) return;

    const shouldRefresh = shouldRefreshOnClose;
    setShouldRefreshOnClose(false);
    closeModal();

    if (shouldRefresh && pathname === '/app/referred') {
      try {
        await refreshReferrals(search || '?page=1');
      } catch {
        // Closing the modal should not surface a fire-and-forget rejection if the refresh fails.
      }
    }
  };

  return (
    <ShareReferralDrawer
      visible={visible}
      fileToken={fileToken}
      cable={cable}
      onClose={handleClose}
      onRevoked={handleRevoked}
      onActivityRead={handleActivityRead}
      afterVisibleChange={handleAfterVisibleChange}
    />
  );
};

SharedReferralDrawerDialog.propTypes = {
  fileToken: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  refreshReferrals: PropTypes.func.isRequired,
  pathname: PropTypes.string,
  search: PropTypes.string,
};

SharedReferralDrawerDialog.defaultProps = {
  pathname: '',
  search: '',
};

export default connect((state) => ({
  fileToken: state.modal.modalType?.data?.fileToken,
  pathname: state.router.location?.pathname,
  search: state.router.location?.search,
}), {
  closeModal: hideModal,
  refreshReferrals: getReferralsQuery,
})(SharedReferralDrawerDialog);
